import { render, staticRenderFns } from "./ChatECard.vue?vue&type=template&id=3a92cc36&scoped=true"
import script from "./ChatECard.vue?vue&type=script&lang=js"
export * from "./ChatECard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a92cc36",
  null
  
)

export default component.exports